import { Link } from "react-router-dom";
import "./AfficheProduit.css";
import { ArticleInfo } from "../../../Modeles/ArticleModel";
import { useContext, useEffect, useState } from "react";
import AfficheArticleInCommercial from "../../../Services/Magasin/AfficheArticleInCommercial";
import { MagasinContext } from "../../../Context/MagasinContext";
import { NewSidebareCommercial } from "../../NewSideBareCommercial";
import axios from "axios";
import defaultImg from "../../Admin/IMG/DefaulteImage.jpeg";

export default function AfficheProduitCommercial() {
  const magasinContext = useContext(MagasinContext);
  const MagasinId = localStorage.getItem("CommercialId");
  const CommercialName = localStorage.getItem("CommercialName");
  const id = MagasinId || magasinContext.id?.id;
  const MagasinName = localStorage.getItem("MagasinName") || "";
  const [selectedFilter, setSelectedFilter] = useState<string>("tout les produits");

  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [products, setProducts] = useState<ArticleInfo[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState<boolean>(false);
  // Per-article annulé / remborsé stats keyed by RefArticle
  const [articleStats, setArticleStats] = useState<Record<string, { annule: number; remborse: number }>>({});

  const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchInput(e.target.value);
    if (e.target.value.trim() === "") {
      setSearch("");
      setCurrentPage(1);
    }
  };

  const triggerSearch = () => {
    setSearch(searchInput.trim());
    setCurrentPage(1);
  };

  const handleSearchKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") triggerSearch();
  };

  // Fetch articles from topArticles or search-articles depending on search query
  useEffect(() => {
    let active = true;
    const fetchArticles = async () => {
      setLoading(true);
      try {
        const query = search.trim();
        let res;
        const extraParams = (selectedFilter === "Mes Produits" && MagasinName)
          ? { magasinName: MagasinName }
          : {};
        if (query === "") {
          res = await axios.get(`${process.env.REACT_APP_PHP_APP_URL}/topArticles`, {
            params: { page: currentPage, perPage: 12, ...extraParams }
          });
        } else {
          res = await axios.get(`${process.env.REACT_APP_PHP_APP_URL}/search-articles`, {
            params: { q: query, page: currentPage, perPage: 12, ...extraParams }
          });
        }
        if (active) {
          const responseData = res.data;
          setProducts(responseData.data || []);
          setTotalPages(responseData.total_pages || responseData.last_page || 1);
          setTotalRecords(responseData.total ?? (responseData.data ? responseData.data.length : 0));
        }
      } catch (err) {
        console.error("Error fetching articles:", err);
        if (active) {
          setProducts([]);
          setTotalPages(1);
          setTotalRecords(0);
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    fetchArticles();
    return () => {
      active = false;
    };
  }, [search, currentPage, selectedFilter, MagasinName]);

  // Fetch per-article stats from backend once on mount
  useEffect(() => {
    if (!id) return;
    axios
      .get(`${process.env.REACT_APP_PHP_APP_URL}/commercial/${id}/article-stats`)
      .then(res => {
        const map: Record<string, { annule: number; remborse: number }> = {};
        (res.data || []).forEach((s: any) => {
          map[s.RefArticle] = { annule: s.annule ?? 0, remborse: s.remborse ?? 0 };
        });
        setArticleStats(map);
      })
      .catch(() => setArticleStats({}));
  }, [id]);

  const currentRecords = products;

  // Helper to extract quantities robustly from any available field (Qte, Quantité, quantite, stock, quantity)
  const getQuantity = (pro: any): number => {
    const parseQty = (val: any): number | null => {
      if (val === undefined || val === null || val === "") return null;
      const clean = String(val).replace(",", ".").trim();
      if (clean === "") return null;
      const n = parseFloat(clean);
      return isNaN(n) ? null : n;
    };
    return parseQty(pro.Qte) 
      ?? parseQty(pro.Quantité) 
      ?? parseQty(pro.quantite) 
      ?? parseQty(pro.stock) 
      ?? parseQty(pro.quantity) 
      ?? 0;
  };

  // Generates clean pagination with ellipses (...) for superior modern UX
  const getVisiblePages = () => {
    const pages: (number | string)[] = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 4) {
        pages.push(1, 2, 3, 4, 5, "...", totalPages);
      } else if (currentPage >= totalPages - 3) {
        pages.push(1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
      }
    }
    return pages;
  };

  /* ---- Sub-components ---- */
  const StatPill = ({
    value,
    label,
    type,
    icon,
  }: {
    value: string | number;
    label: string;
    type: "ventes" | "annules" | "rembourses";
    icon: string;
  }) => (
    <div className={`stat-pill-dpnd-commercial-u ${type}-dpnd-commercial-u`}>
      <i className={`bi ${icon} stat-pill-icon`}></i>
      <span className="stat-num-dpnd-commercial-u">{value}</span>
      <span className="stat-label-dpnd-commercial-u">{label}</span>
    </div>
  );

  const ProductCard = ({ pro }: { pro: any }) => {
    const ref = pro.RefArticle || pro.ref || pro.Reference || pro.reference || '';
    const stats = articleStats[ref] ?? { annule: 0, remborse: 0 };
    const availableQty = getQuantity(pro);
    const outOfStock = availableQty <= 0;

    return (
      <div className={`product-card-dpnd-commercial-u ${outOfStock ? 'u-card-nostock-commercial-u' : ''}`} style={outOfStock ? { opacity: 0.8 } : undefined}>
        {/* Image area */}
        <div className="card-img-area-dpnd-commercial-u" style={{ position: 'relative' }}>
          <img
            src={pro.urlImage || defaultImg}
            alt={pro.Designation}
            className="card-img-dpnd-commercial-u"
            style={outOfStock ? { filter: 'grayscale(100%)', opacity: 0.6 } : undefined}
            loading="lazy"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = defaultImg;
            }}
          />
          {outOfStock && (
            <div className="stock-badge-dpnd-commercial-u out-of-stock" style={{ position: 'absolute', top: 10, left: 10, background: 'rgba(255,255,255,0.95)', border: '1px solid rgba(239, 68, 68, 0.3)', zIndex: 2 }}>
              <i className="bi bi-x-circle-fill"></i> Stock épuisé
            </div>
          )}
          <div className="card-actions-dpnd-commercial-u">
            <button className="action-icon-dpnd-commercial-u" title="Ajouter aux favoris">
              <i className="bi bi-suit-heart-fill"></i>
            </button>
            <button className="action-icon-dpnd-commercial-u" title="Partager le produit">
              <i className="bi bi-share-fill"></i>
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="card-body-dpnd-commercial-u">
          <div className="card-meta-row-dpnd">
            <span className="card-ref-badge" title={`Réf: ${ref}`}>
              <i className="bi bi-hash" style={{ color: "#F5A623", marginRight: "2px" }}></i>
              Réf : {ref || "N/A"}
            </span>
          </div>

          <div className="card-name-dpnd-commercial-u" title={pro.Designation}>
            {pro.Designation}
          </div>

          {/* Price display with old price if discount */}
          {(() => {
            const remise = parseFloat((localStorage.getItem("remise") || "0").replace("%", "")) || 0;
            const pHT = parseFloat(String(pro.PrixNetHT ?? pro.PrixVenteArticleTTC ?? pro.PrixVente ?? pro.Prix ?? "0").replace(",", ".").trim()) || 0;
            const oldPrice = remise > 0 ? pHT * (1 + remise / 100) : pHT;
            const newPrice = remise > 0 ? oldPrice * (1 - remise / 100) : oldPrice;
            const showOldPrice = remise > 0 && pHT > 0;
            return (
              <div style={{ margin: "8px 0" }}>
                {showOldPrice && (
                  <span style={{ textDecoration: "line-through", color: "#9CA3AF", fontSize: "0.85rem", marginRight: "8px", fontWeight: 600 }}>
                    {oldPrice.toFixed(2)} MAD
                  </span>
                )}
                <span style={{ fontWeight: 800, color: "#1E293B", fontSize: "1.1rem" }}>
                  {newPrice.toFixed(2)} MAD
                </span>
              </div>
            );
          })()}

          <div className="stats-row-dpnd-commercial-u">
            <StatPill 
              value={stats.annule} 
              label="Annulés" 
              type="annules" 
              icon="bi-x-circle" 
            />
            <StatPill 
              value={stats.remborse} 
              label="Remboursés" 
              type="rembourses" 
              icon="bi-arrow-counterclockwise" 
            />
          </div>

        </div>

        <div className="card-footer-dpnd-commercial-u">
          <Link
            className="detail-btn-dpnd-commercial-u"
            to={`/commercials/${id}/${pro.NomMagasin || MagasinName}/articles/${btoa(String(pro.RefArticle))}`}
          >
            <span>Voir détails</span>
            <i className="bi bi-chevron-right btn-chevron-icon"></i>
          </Link>
        </div>
      </div>
    );
  };

  const EmptyState = () => (
    <div className="empty-state-dpnd-commercial-u">
      <div className="empty-icon-dpnd-commercial-u">
        <i className="bi bi-search"></i>
      </div>
      <h5 className="empty-title-dpnd-commercial-u">Aucun résultat trouvé</h5>
      <p className="empty-sub-dpnd-commercial-u">
        Essayez un mot similaire ou quelque chose de plus général.
      </p>
    </div>
  );

  return (
    <div className="page-wrapper-dpnd-commercial-u">
      <NewSidebareCommercial />

      <div className="page-inner-dpnd-commercial-u">
        {/* Header */}
        <div className="page-header-dpnd-commercial-u">
          <div className="header-info-block">
            <h1 className="page-title-dpnd-commercial-u">
              Mes <em>Articles</em>
            </h1>
            <p className="page-subtitle-dpnd-commercial-u">
              Explorez le catalogue de produits, gérez vos ventes et supervisez les stocks en temps réel.
            </p>
          </div>
          {!loading && (
            <span className="count-badge-dpnd-commercial-u">
              <i className="bi bi-box-seam count-badge-icon"></i>
              {totalRecords} article{totalRecords !== 1 ? "s" : ""}
            </span>
          )}
        </div>

        {/* Filter buttons */}
        <div style={{ display: "flex", gap: "10px", margin: "14px 0", flexWrap: "wrap" }}>
          {["tout les produits", "Mes Produits"].map((f) => (
            <button
              key={f}
              onClick={() => { setSelectedFilter(f); setCurrentPage(1); }}
              style={{
                padding: "8px 20px",
                borderRadius: "20px",
                border: selectedFilter === f ? "1px solid #F5A623" : "1px solid #E2E8F0",
                background: selectedFilter === f ? "#F5A623" : "#FFFFFF",
                color: selectedFilter === f ? "#FFFFFF" : "#475569",
                fontWeight: 600,
                fontSize: "0.85rem",
                cursor: "pointer",
                boxShadow: selectedFilter === f ? "0 2px 6px rgba(245, 166, 35, 0.3)" : "none",
                transition: "all 0.2s"
              }}
            >
              {f === "tout les produits" ? "Tous les produits" : "Mes Produits"}
            </button>
          ))}
        </div>

        {/* Toolbar */}
        <div className="toolbar-dpnd-commercial-u">
          <div className="search-box-dpnd-commercial-u">
            <i
              className="bi bi-search search-icon-dpnd-commercial-u"
              style={{ cursor: "pointer" }}
              onClick={triggerSearch}
            ></i>
            <input
              type="text"
              value={searchInput}
              onChange={handleSearchInputChange}
              onKeyDown={handleSearchKeyDown}
              className="search-input-dpnd-commercial-u"
              placeholder="Rechercher un produit, référence..."
            />
            {searchInput && (
              <button 
                className="search-clear-btn-dpnd" 
                onClick={() => { setSearchInput(""); setSearch(""); setCurrentPage(1); }}
                title="Effacer la recherche"
              >
                <i className="bi bi-x-circle-fill"></i>
              </button>
            )}
          </div>
        </div>

        {/* Content */}
        {loading ? (
          <div className="loading-dpnd-commercial-u">
            <div className="spinner-dpnd-commercial-u"></div>
            <span className="loading-text-dpnd-commercial-u">Chargement des articles...</span>
          </div>
        ) : currentRecords.length > 0 ? (
          <>
            <div className="product-grid-dpnd-commercial-u">
              {currentRecords.map((pro) => (
                <ProductCard key={`${pro.IdArticle || pro.id}-${pro.RefArticle}`} pro={pro} />
              ))}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="pagination-dpnd-commercial-u">
                <button
                  className="page-btn-dpnd-commercial-u page-nav-dpnd-commercial-u"
                  onClick={() => setCurrentPage((p) => p - 1)}
                  disabled={currentPage === 1}
                >
                  <i className="bi bi-chevron-left"></i> Préc.
                </button>

                {getVisiblePages().map((n, idx) => {
                  if (n === "...") {
                    return (
                      <span key={`dots-${idx}`} className="pagination-dots" style={{ margin: "0 8px", color: "#64748B", alignSelf: "center", fontWeight: 600 }}>
                        ...
                      </span>
                    );
                  }
                  return (
                    <button
                      key={n}
                      className={`page-btn-dpnd-commercial-u ${
                        currentPage === n ? "active-dpnd-commercial-u" : ""
                      }`}
                      onClick={() => setCurrentPage(n as number)}
                    >
                      {n}
                    </button>
                  );
                })}

                <button
                  className="page-btn-dpnd-commercial-u page-nav-dpnd-commercial-u"
                  onClick={() => setCurrentPage((p) => p + 1)}
                  disabled={currentPage === totalPages}
                >
                  Suiv. <i className="bi bi-chevron-right"></i>
                </button>
              </div>
            )}
          </>
        ) : (
          <EmptyState />
        )}
      </div>
    </div>
  );
}